export default {
    textAlign: {
        template: 'Tab',
        label: 'Alignment',
        inputType: 'boxed',
        isResponsible: true,
        labelPosition: 'top',
        defaultValue: 'left',
        options: [
            { label: 'Left', value: 'left' },
            { label: 'Center', value: 'center' },
            { label: 'Right', value: 'right' },
        ],
    },
    display: {
        inputType: 'select',
        label: 'Display',
        template: 'Select',
        options: [
            {
                name: 'Block',
                value: 'block',
            },
            {
                name: 'Inline Block',
                value: 'inline-block',
            },
        ],
    },
    // ATTRIBUTES
    attr: {
        href: {
            label: 'URL',
            template: 'Input',
        },
        target: {
            template: 'Tab',
            defaultValue: '',
            inputType: 'boxed',
            label: 'Open Link In',
            options: [
                { label: 'Same Tab', value: '' },
                { label: 'New Tab', value: '_blank' },
                { label: 'New Window', value: '_new' },
            ],
        },
    },
};
